import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import PlaylistReducer from "./reducers/playlists";
import SectionReducer from "./reducers/sections";
import GameReducer from "./reducers/game";
import RecentlyReducer from "./reducers/recently";

const middlewareEnhancer = applyMiddleware(thunk);
const composedEnhancers = compose(
  middlewareEnhancer
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

let store = createStore(
  combineReducers({
    playlists: PlaylistReducer,
    game: GameReducer,
    recently: RecentlyReducer,
    sections: SectionReducer,
  }),
  composedEnhancers
);

export default store;
